var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nr_container_content mt-60" },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_successfully",
        staticClass: "modal_contents_successfully",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3" }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Ваши ответы приняты"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Благодарим вас за уделенное время!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-modal-contents", {
        ref: "modal_alert",
        staticClass: "modal_alert",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Уведомление"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Пожалуйста, ответьте на все вопросы."),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "poll",
          class: _vm.validAll ? "valid" : "noValid",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label: "1. Как давно ваша компания сотрудничает с NOVAROLL?",
              },
              model: {
                value: _vm.cooperationDuration,
                callback: function ($$v) {
                  _vm.cooperationDuration = $$v
                },
                expression: "cooperationDuration",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Менее года",
                  value: "Менее года",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "1 - 3 года",
                  value: "1 - 3 года",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Более 3-х лет",
                  value: "Более 3-х лет",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label: "2. Как часто вы размещаете заказы в NOVAROLL?",
              },
              model: {
                value: _vm.orderFrequency,
                callback: function ($$v) {
                  _vm.orderFrequency = $$v
                },
                expression: "orderFrequency",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Несколько раз в неделю",
                  value: "Несколько раз в неделю",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Раз в неделю",
                  value: "Раз в неделю",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Раз в две недели",
                  value: "Раз в две недели",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Раз в месяц",
                  value: "Раз в месяц",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Реже одного раза в месяц",
                  value: "Реже одного раза в месяц",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "3. Сколько времени занимает весь цикл от момента размещения до получения товара/услуги?",
              },
              model: {
                value: _vm.orderCycleTime,
                callback: function ($$v) {
                  _vm.orderCycleTime = $$v
                },
                expression: "orderCycleTime",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "От 1 до 3 дней",
                  value: "От 1 до 3 дней",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "От 4 до 7 дней",
                  value: "От 4 до 7 дней",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "От 8 до 14 дней",
                  value: "От 8 до 14 дней",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Более 2 недель",
                  value: "Более 2 недель",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom_label",
              class:
                this.novarollOrderMethods.length === 0 ? "noValidError" : "",
            },
            [_vm._v("4. Как вы обычно размещаете заказ в NOVAROLL?")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-35 checkbox_group" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "По телефону",
                  value: "По телефону",
                },
                model: {
                  value: _vm.novarollOrderMethods,
                  callback: function ($$v) {
                    _vm.novarollOrderMethods = $$v
                  },
                  expression: "novarollOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "По электронной почте",
                  value: "По электронной почте",
                },
                model: {
                  value: _vm.novarollOrderMethods,
                  callback: function ($$v) {
                    _vm.novarollOrderMethods = $$v
                  },
                  expression: "novarollOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "В мессенджерах",
                  value: "В мессенджерах",
                },
                model: {
                  value: _vm.novarollOrderMethods,
                  callback: function ($$v) {
                    _vm.novarollOrderMethods = $$v
                  },
                  expression: "novarollOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "На онлайн-портале",
                  value: "На онлайн-портале",
                },
                model: {
                  value: _vm.novarollOrderMethods,
                  callback: function ($$v) {
                    _vm.novarollOrderMethods = $$v
                  },
                  expression: "novarollOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
                model: {
                  value: _vm.novarollOrderMethods,
                  callback: function ($$v) {
                    _vm.novarollOrderMethods = $$v
                  },
                  expression: "novarollOrderMethods",
                },
              }),
              _vm._v(" "),
              _vm.novarollOrderMethods.includes("Другое")
                ? _c("v-text-field", {
                    staticClass: "different_el",
                    attrs: {
                      label: "Укажите способ",
                      color: "red",
                      placeholder: "Ваш ответ...",
                    },
                    model: {
                      value: _vm.novarollOrderMethodsOther,
                      callback: function ($$v) {
                        _vm.novarollOrderMethodsOther = $$v
                      },
                      expression: "novarollOrderMethodsOther",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom_label",
              class:
                this.otherSuppliersOrderMethods.length === 0
                  ? "noValidError"
                  : "",
            },
            [_vm._v("5. Как вы обычно размещаете заказ у других поставщиков?")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-35 checkbox_group" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "По телефону",
                  value: "По телефону",
                },
                model: {
                  value: _vm.otherSuppliersOrderMethods,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderMethods = $$v
                  },
                  expression: "otherSuppliersOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "По электронной почте",
                  value: "По электронной почте",
                },
                model: {
                  value: _vm.otherSuppliersOrderMethods,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderMethods = $$v
                  },
                  expression: "otherSuppliersOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "В мессенджерах",
                  value: "В мессенджерах",
                },
                model: {
                  value: _vm.otherSuppliersOrderMethods,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderMethods = $$v
                  },
                  expression: "otherSuppliersOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "На онлайн-портале",
                  value: "На онлайн-портале",
                },
                model: {
                  value: _vm.otherSuppliersOrderMethods,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderMethods = $$v
                  },
                  expression: "otherSuppliersOrderMethods",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
                model: {
                  value: _vm.otherSuppliersOrderMethods,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderMethods = $$v
                  },
                  expression: "otherSuppliersOrderMethods",
                },
              }),
              _vm._v(" "),
              _vm.otherSuppliersOrderMethods.includes("Другое")
                ? _c("v-text-field", {
                    staticClass: "different_el",
                    attrs: {
                      label: "Укажите способ",
                      color: "red",
                      placeholder: "Ваш ответ...",
                    },
                    model: {
                      value: _vm.otherSuppliersOrderMethodsOther,
                      callback: function ($$v) {
                        _vm.otherSuppliersOrderMethodsOther = $$v
                      },
                      expression: "otherSuppliersOrderMethodsOther",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "6. Насколько удобен для вас процесс размещения заказа в NOVAROLL?",
              },
              model: {
                value: _vm.novarollOrderConvenience,
                callback: function ($$v) {
                  _vm.novarollOrderConvenience = $$v
                },
                expression: "novarollOrderConvenience",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Очень удобно",
                  value: "Очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Удобно", value: "Удобно" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Не очень удобно",
                  value: "Не очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Совсем неудобно",
                  value: "Совсем неудобно",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "7. Насколько удобен для вас процесс размещения заказа у других поставщиков?",
              },
              model: {
                value: _vm.otherSuppliersOrderConvenience,
                callback: function ($$v) {
                  _vm.otherSuppliersOrderConvenience = $$v
                },
                expression: "otherSuppliersOrderConvenience",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Очень удобно",
                  value: "Очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Удобно", value: "Удобно" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Не очень удобно",
                  value: "Не очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Совсем неудобно",
                  value: "Совсем неудобно",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "8. Насколько вам удобно отслеживать статус вашего заказа NOVAROLL?",
              },
              model: {
                value: _vm.orderTrackingConvenience,
                callback: function ($$v) {
                  _vm.orderTrackingConvenience = $$v
                },
                expression: "orderTrackingConvenience",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Очень удобно",
                  value: "Очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Удобно", value: "Удобно" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Не очень удобно",
                  value: "Не очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Совсем неудобно",
                  value: "Совсем неудобно",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom_label",
              class:
                this.paymentDifficulties.length === 0 ? "noValidError" : "",
            },
            [
              _vm._v(
                "9. С какими трудностями вы сталкиваетесь при оплате заказов NOVAROLL?"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-3 checkbox_group" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Неудобен способ оплаты",
                  value: "Неудобен способ оплаты",
                },
                model: {
                  value: _vm.paymentDifficulties,
                  callback: function ($$v) {
                    _vm.paymentDifficulties = $$v
                  },
                  expression: "paymentDifficulties",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Задержки транзакций",
                  value: "Задержки транзакций",
                },
                model: {
                  value: _vm.paymentDifficulties,
                  callback: function ($$v) {
                    _vm.paymentDifficulties = $$v
                  },
                  expression: "paymentDifficulties",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Отсутствие информации о подтверждении платежа",
                  value: "Отсутствие информации о подтверждении платежа",
                },
                model: {
                  value: _vm.paymentDifficulties,
                  callback: function ($$v) {
                    _vm.paymentDifficulties = $$v
                  },
                  expression: "paymentDifficulties",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
                model: {
                  value: _vm.paymentDifficulties,
                  callback: function ($$v) {
                    _vm.paymentDifficulties = $$v
                  },
                  expression: "paymentDifficulties",
                },
              }),
              _vm._v(" "),
              _vm.paymentDifficulties.includes("Другое")
                ? _c("v-text-field", {
                    staticClass: "different_el ",
                    attrs: {
                      label: "Укажите вопрос",
                      color: "red",
                      placeholder: "Ваш ответ...",
                    },
                    model: {
                      value: _vm.paymentDifficultiesText,
                      callback: function ($$v) {
                        _vm.paymentDifficultiesText = $$v
                      },
                      expression: "paymentDifficultiesText",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "10. Какие основные проблемы возникают при текущем способе размещения заказов в NOVAROLL? (укажите)",
              rules: _vm.rulesFild,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.orderPlacementProblems,
              callback: function ($$v) {
                _vm.orderPlacementProblems = $$v
              },
              expression: "orderPlacementProblems",
            },
          }),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "11. Сколько времени в среднем уходит на размещение и получение подтверждения заказа NOVAROLL?",
              },
              model: {
                value: _vm.orderPlacementTime,
                callback: function ($$v) {
                  _vm.orderPlacementTime = $$v
                },
                expression: "orderPlacementTime",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Менее 5 минут",
                  value: "Менее 5 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "От 5 до 20 минут",
                  value: "От 5 до 20 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Более 20 минут",
                  value: "Более 20 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.orderPlacementTime === "Другое"
            ? _c("v-text-field", {
                staticClass: "different_el",
                attrs: { label: "Укажите время", color: "red" },
                model: {
                  value: _vm.otherOrderPlacementTime,
                  callback: function ($$v) {
                    _vm.otherOrderPlacementTime = $$v
                  },
                  expression: "otherOrderPlacementTime",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "12. Сколько времени в среднем уходит на размещение и получение подтверждения заказа у других поставщиков?",
              },
              model: {
                value: _vm.otherSuppliersOrderPlacementTime,
                callback: function ($$v) {
                  _vm.otherSuppliersOrderPlacementTime = $$v
                },
                expression: "otherSuppliersOrderPlacementTime",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Менее 5 минут",
                  value: "Менее 5 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "От 5 до 20 минут",
                  value: "От 5 до 20 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Более 20 минут",
                  value: "Более 20 минут",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.otherSuppliersOrderPlacementTime === "Другое"
            ? _c("v-text-field", {
                staticClass: "different_el",
                attrs: {
                  label: "Укажите время",
                  color: "red",
                  placeholder: "Ваш ответ...",
                },
                model: {
                  value: _vm.otherSuppliersOrderPlacementTimeText,
                  callback: function ($$v) {
                    _vm.otherSuppliersOrderPlacementTimeText = $$v
                  },
                  expression: "otherSuppliersOrderPlacementTimeText",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "13. Пользовались ли вы когда-либо онлайн-порталом поставщика для заказа товаров в вашей работе?",
              },
              model: {
                value: _vm.usedOnlinePortal,
                callback: function ($$v) {
                  _vm.usedOnlinePortal = $$v
                },
                expression: "usedOnlinePortal",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "14. Насколько удобно вам было размещать заказ на онлайн-портале?",
              },
              model: {
                value: _vm.onlinePortalConvenience,
                callback: function ($$v) {
                  _vm.onlinePortalConvenience = $$v
                },
                expression: "onlinePortalConvenience",
              },
            },
            [
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Очень удобно",
                  value: "Очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Удобно", value: "Удобно" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Не очень удобно",
                  value: "Не очень удобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Совсем неудобно",
                  value: "Совсем неудобно",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Не пользуюсь",
                  value: "Не пользуюсь",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "15. Используются ли в вашей компании собственные онлайн-порталы (платформы) для взаимодействия с поставщиками?",
              },
              model: {
                value: _vm.ownOnlinePortals,
                callback: function ($$v) {
                  _vm.ownOnlinePortals = $$v
                },
                expression: "ownOnlinePortals",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "16. Удобно ли вам было бы размещать заказы в NOVAROLL на онлайн-портале на постоянной основе?",
              },
              model: {
                value: _vm.wantOnlinePortal,
                callback: function ($$v) {
                  _vm.wantOnlinePortal = $$v
                },
                expression: "wantOnlinePortal",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "17. Какой функционал для вас самый полезный при использовании онлайн-портала для заказа товаров? ",
              rows: "1",
              "auto-grow": "",
              rules: _vm.rulesFild,
              required: "",
            },
            model: {
              value: _vm.portalFunctionality,
              callback: function ($$v) {
                _vm.portalFunctionality = $$v
              },
              expression: "portalFunctionality",
            },
          }),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "18. Хотите ли вы получать уведомления об изменении статуса заказа по электронной почте или SMS?",
              },
              model: {
                value: _vm.orderStatusNotifications,
                callback: function ($$v) {
                  _vm.orderStatusNotifications = $$v
                },
                expression: "orderStatusNotifications",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "19. Нужен ли вам доступ к истории ваших предыдущих заказов?",
              },
              model: {
                value: _vm.accessOrderHistory,
                callback: function ($$v) {
                  _vm.accessOrderHistory = $$v
                },
                expression: "accessOrderHistory",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "20. Актуальна ли для вас возможность оставлять отзывы на портале после выполнения заказа?",
              },
              model: {
                value: _vm.leaveFeedback,
                callback: function ($$v) {
                  _vm.leaveFeedback = $$v
                },
                expression: "leaveFeedback",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Да", value: "Да" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Нет", value: "Нет" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Затрудняюсь ответить",
                  value: "Затрудняюсь ответить",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-radio-group",
            {
              attrs: {
                rules: _vm.rulesFild,
                required: "",
                label:
                  "21. Как часто вам приходится дополнительно обращаться к менеджерам по продажам для уточнения деталей заказа до момента его доставки?",
              },
              model: {
                value: _vm.contactSalesManagersFrequency,
                callback: function ($$v) {
                  _vm.contactSalesManagersFrequency = $$v
                },
                expression: "contactSalesManagersFrequency",
              },
            },
            [
              _c("v-radio", {
                attrs: { color: "red", label: "Никогда", value: "Никогда" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Редко", value: "Редко" },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: {
                  color: "red",
                  label: "Очень часто",
                  value: "Очень часто",
                },
              }),
              _vm._v(" "),
              _c("v-radio", {
                attrs: { color: "red", label: "Всегда", value: "Всегда" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "custom_label",
              class:
                this.salesManagerQuestions.length === 0 ? "noValidError" : "",
            },
            [
              _vm._v(
                "22. Какие вопросы приходится уточнять у менеджера по продажам?"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4 checkbox_group" },
            [
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Статус платежа",
                  value: "Статус платежа",
                },
                model: {
                  value: _vm.salesManagerQuestions,
                  callback: function ($$v) {
                    _vm.salesManagerQuestions = $$v
                  },
                  expression: "salesManagerQuestions",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Статус готовности товара к отгрузке",
                  value: "Статус готовности товара к отгрузке",
                },
                model: {
                  value: _vm.salesManagerQuestions,
                  callback: function ($$v) {
                    _vm.salesManagerQuestions = $$v
                  },
                  expression: "salesManagerQuestions",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Статус доставки",
                  value: "Статус доставки",
                },
                model: {
                  value: _vm.salesManagerQuestions,
                  callback: function ($$v) {
                    _vm.salesManagerQuestions = $$v
                  },
                  expression: "salesManagerQuestions",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Не приходилось уточнять",
                  value: "Не приходилось уточнять",
                },
                model: {
                  value: _vm.salesManagerQuestions,
                  callback: function ($$v) {
                    _vm.salesManagerQuestions = $$v
                  },
                  expression: "salesManagerQuestions",
                },
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                attrs: {
                  color: "red",
                  label: "Другое (указать)",
                  value: "Другое",
                },
                model: {
                  value: _vm.salesManagerQuestions,
                  callback: function ($$v) {
                    _vm.salesManagerQuestions = $$v
                  },
                  expression: "salesManagerQuestions",
                },
              }),
              _vm._v(" "),
              _vm.salesManagerQuestions.includes("Другое")
                ? _c("v-text-field", {
                    staticClass: "different_el",
                    attrs: {
                      label: "Укажите вопрос",
                      color: "red",
                      placeholder: "Ваш ответ...",
                    },
                    model: {
                      value: _vm.salesManagerQuestionsOther,
                      callback: function ($$v) {
                        _vm.salesManagerQuestionsOther = $$v
                      },
                      expression: "salesManagerQuestionsOther",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "23. Если бы вы могли изменить что-то одно в существующей системе размещения и выполнения заказа, что бы вы улучшили? ",
              rules: _vm.rulesFild,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.suggestionForImprovement,
              callback: function ($$v) {
                _vm.suggestionForImprovement = $$v
              },
              expression: "suggestionForImprovement",
            },
          }),
          _vm._v(" "),
          _c("v-textarea", {
            attrs: {
              placeholder: "Ваш ответ...",
              color: "red",
              label:
                "24. Что бы вы хотели улучшить во взаимодействии с компанией NOVAROLL? ",
              rules: _vm.rulesFild,
              required: "",
              rows: "1",
              "auto-grow": "",
            },
            model: {
              value: _vm.improvementSuggestions,
              callback: function ($$v) {
                _vm.improvementSuggestions = $$v
              },
              expression: "improvementSuggestions",
            },
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mt-30",
              attrs: { color: "#f94237" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submitSurvey.apply(null, arguments)
                },
              },
            },
            [_vm._v("Отправить")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }